import {safeRandomUUID} from 'lib/cryptoFallback';

/** Analytics IDs are not credentials. Missing crypto must not block product actions. */
export function measurementId(): string {
    try { return safeRandomUUID(); }
    catch { return `measurement-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`; }
}

/** Identifiers and dimensions only: no text, filenames, email or payment credentials. */
export interface ScanMeasurement {
    scan_attempt_id?: string;
    analysis_id?: number;
    analysis_uuid?: string;
    document_id?: string;
    input_type?: 'text' | 'document' | 'batch';
    text_chars?: number;
    word_count?: number;
    file_count?: number;
    task_id?: number;
    elapsed_ms?: number;
}

export function fileType(name: string): string {
    const extension = name.split('.').pop()?.toLowerCase();
    return extension && ['pdf', 'docx', 'doc', 'txt'].includes(extension) ? extension : 'other';
}
